import React from 'react';
import './App.css';
import { Navigate, Route, Routes } from 'react-router-dom';
import Login from '../Common/Login';
import Dashboard from './Dashboard';
// import { usePWAInstall } from 'react-use-pwa-install'
import Archive from './../Customer/Archive';
import CreateCustomer from './../Customer/CreateCustomer';
import NotFound from './../Common/NotFound';
import Menu from '../DynamicMenu/Menu';

function App() {
  // const install = usePWAInstall()



  return (
    <div className="App">
      <Routes>
        <Route path="/"  element={<Login />} />
        <Route path="/dashboard/archive" exact element={<Archive />} />
        <Route path="/dashboard/create-customer" exact element={<CreateCustomer />} />
        <Route path="/dashboard" exact element={<Dashboard />} />
        <Route path="/online/:name/*" exact element={<Menu />} />
        <Route path="/not-found" exact element={<NotFound />} />
        <Route path="*" element={<Navigate replace to='/not-found' />} />
      </Routes>
    </div>
  );
}

export default App;
